import React from 'react';
import classnames from 'classnames';
import BlogSections from '../BlogSections';
import ArticleLink from '../models/ArticleLink';
import { blogEndpoint } from '../Blog';
import BlogAddToFavouritesButton from './BlogAddToFavouritesButton';
import Link from '@/components/Link';
import bemBlock from '@gik/core/utils/bemBlock';

interface ArticleAuthorLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  articleLink: ArticleLink;
}

export default function ArticleAuthorLink({ articleLink, className }: ArticleAuthorLinkProps): React.ReactElement {
  const child = <span className="author">BY {articleLink.authorFullName.toUpperCase()}</span>;
  const authorContainer = articleLink.authorSlug ? (
    <Link href={`/${blogEndpoint}/${BlogSections.authors}/${articleLink.authorSlug}`}>
      <a>{child}</a>
    </Link>
  ) : (
    child
  );

  const bem = bemBlock('author-link');
  const blockClasses = classnames(bem(), className || '');
  return (
    <div className={blockClasses}>
      <BlogAddToFavouritesButton type="articles" typeId={articleLink.articleId} />
      {authorContainer}
    </div>
  );
}
